/* eslint-disable max-len */
import {
    GridColumnVisibilityModel,
} from '@mui/x-data-grid-pro'
import {
    ExtendedGridColDef,
} from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/SkyBaseDataGrid.types'

export const DEFAULT_MAIN_TABLE_IN_DETAILS_VIEW_WIDTH_PERCENT = 20
export const NEW_COLUMN_BREAKPOINT = 12 // percent margin for each new column to show

export const getTargetVisibleColumnsCount = (newTableWidthPercent: number,
    initialTableWidthPercent: number, allColumnsLength: number) => {
    let targetVisibleColumnsCount = 1

    // If table has grown beyond initial width plus breakpoint, show more columns
    if (newTableWidthPercent > initialTableWidthPercent + NEW_COLUMN_BREAKPOINT) {
        const diff = newTableWidthPercent - initialTableWidthPercent
        const additionalColumnsCount = Math.floor(diff / NEW_COLUMN_BREAKPOINT)

        targetVisibleColumnsCount = Math.max(
            targetVisibleColumnsCount,
            Math.min(1 + additionalColumnsCount, allColumnsLength),
        )
    }
    targetVisibleColumnsCount = Math.min(targetVisibleColumnsCount, allColumnsLength)
    return targetVisibleColumnsCount
}

export const getOnlyReducedColumnsVisibilityModel = (columns: ExtendedGridColDef[]): GridColumnVisibilityModel => {
    return Object.fromEntries(
        columns.map((column) => {
            return [
                column.name,
                Boolean(column.reduced),
            ]
        }),
    )
}

export const getOnlyFirstColumnVisibilityModel = (columns: ExtendedGridColDef[]): GridColumnVisibilityModel => {
    return Object.fromEntries(
        columns.map((column, index) => {
            return [
                column.name,
                index < 1,
            ]
        }),
    )
}

export const getFirstReducedColumnVisibilityModel = (columns: ExtendedGridColDef[]): GridColumnVisibilityModel => {
    const firstReducedColumn = columns.findIndex((column) => { return Boolean(column.reduced) })

    return Object.fromEntries(
        columns.map((column, index) => {
            return [
                column.name,
                index === firstReducedColumn,
            ]
        }),
    )
}

export const getCurrentlyVisibleColumnsNames = (visibilityModel: GridColumnVisibilityModel): string[] => {
    return Object.entries(visibilityModel)
        .filter(([
            _, // eslint-disable-line @typescript-eslint/no-unused-vars
            isVisible,
        ]) => {
            return isVisible
        })
        .map(([columnName]) => {
            return columnName
        })
}
